module.exports = __webpack_public_path__ + "img/pantalla-7-3.1e89af17.png";